import axios from 'axios'; // Import sab se upar agaya

export const APP_CONFIG = {
    TITLE: "United Motors ERP",
    FOOTER_TEXT: "United Motors Rawalpindi",
    ADDRESS: "Main Service Road, Rawalpindi, Pakistan",
    CONTACT: "+92 300 1234567",
};


//export const API_BASE_URL = "http://localhost:5000/api";
export const API_BASE_URL = "https://unitedautomotors.store/api";
const instance = axios.create({
    baseURL: API_BASE_URL
});

// Request Interceptor
instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor
instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default instance;